export const internalUsersDomains = [
  '@twlvxtwlv.com',
  '@exxeta.com',
  '@360xmusic.com',
  '@360x.com',
] as const
